
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gemini-api-key-setup-guide-for-beginners",
      function () {
        return require("private-next-pages/gemini-api-key-setup-guide-for-beginners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gemini-api-key-setup-guide-for-beginners"])
      });
    }
  